<template>
  <nav v-if="!isMobileOrTablet" aria-label="Footer Menu Links" class="grid-default">
    <FooterMenuListItem v-for="item in parents" :key="item.id" class="col-span-2" :data="item" />
  </nav>
  <nav aria-label="Mobile Footer Menu Links" class="-mx-4">
    <LazyFooterMenuSwiper v-if="isMobileOrTablet" :data="parents" />
  </nav>
</template>

<script setup lang="ts">
import type { FooterMenuItemRecord } from '~/types/datocms'
const { isMobileOrTablet } = useDevice()

const props = defineProps({
  data: {
    type: Array as PropType<FooterMenuItemRecord[]>,
    default: () => []
  }
})

// Filter top level items
const parents = computed(() => props.data.filter((item) => item.parent === null))
</script>
